import type { en } from "./en";

export const ru: typeof en = {
  meta: {
    title: "BackDoor — Хакай головой, а не руками",
    brand: "BackDoor",
  },

  common: {
    loading: "Загрузка…",
    cancel: "Отмена",
    confirm: "Подтвердить",
    close: "Закрыть",
    delete: "Удалить",
    save: "Сохранить",
    create: "Создать",
    edit: "Изменить",
    retry: "Повторить",
    refresh: "Обновить",
    copy: "Скопировать",
    copied: "Скопировано",
    download: "Скачать",
    open: "Открыть",
    yes: "Да",
    no: "Нет",
    enter: "Войти",
    dash: "—",
  },

  nav: {
    overview: "Обзор",
    findings: "Уязвимости",
    hypoteses: "Гипотезы",
    attackGraph: "Граф атак",
    liveFeed: "События",
    reports: "Отчёты",
    settings: "Настройки",
    signOut: "Выйти",
    menu: "Меню",
    confirmSignOutTitle: "Выйти из аккаунта?",
    confirmSignOutBody: "Вы вернётесь на экран входа.",
  },

  topbar: {
    llms: "LLM",
    connection: "соединение",
    refresh: "Обновить",
    notifications: "Уведомления",
    notifEmpty: "Новых уведомлений нет",
    markAllRead: "Прочитать все",
  },

  projects: {
    label: "ПРОЕКТЫ",
    newProject: "Новый проект",
    newScan: "+ Новое сканирование",
    openScans: "Показать сканы",
    moreActions: "Ещё",
    deleteProject: "Удалить проект",
    noScans: "Сканирований пока нет",
    scanRunningTitle: "Сканирование уже идёт",
    scanRunningBody:
      "По этому проекту уже выполняется сканирование. Отмените или дождитесь окончания, чтобы начать новое.",
    gotIt: "Понятно",
    scanStartFailed: "Не удалось запустить сканирование",
    confirmDeleteTitle: "Удалить этот проект?",
    confirmDeleteBody: 'Проект «{name}» и его область будут удалены безвозвратно.',
    deleteFailed: "Не удалось удалить проект",
    statusRunning: "идёт",
    statusPaused: "пауза",
    statusReady: "готово",
    statusCancelled: "отменено",
    statusFailed: "ошибка",
  },

  scan: {
    elapsed: "прошло",
    pause: "Пауза",
    resume: "Продолжить",
    pauseScan: "Поставить на паузу",
    resumeScan: "Возобновить сканирование",
    cancelScan: "Отменить сканирование",
    confirmCancelTitle: "Отменить это сканирование?",
    confirmCancelBody:
      "Отмена остановит выполнение и переведёт сканирование в статус CANCELLED.",
    confirmCancelLabel: "Отменить сканирование",
    none: "Сканирование не запущено",
    startHint: "Запустите сканирование из одного из ваших проектов.",
    startCta: "Запустить скан",
    startCtaBusy: "Запускаем…",
    startCtaTitle: "Нажми play! Запусти сканирование",
    phaseRecon: "Разведка",
    phaseMap: "Карта",
    phaseAnalyze: "Анализ",
    phaseExploit: "Эксплойт",
    phaseChain: "Цепочка",
    phaseReport: "Отчёт",
    graphTitle: "Граф миссии",
    graphLoading: "Загрузка графа…",
    graphEmpty: "Выберите скан, чтобы увидеть граф миссии в реальном времени.",
    graphNoNodes: "Узлов пока нет.",
    graphLoadFailed: "Не удалось загрузить граф: {error}",
    graphDirTB: "Сверху вниз",
    graphDirLR: "Слева направо",
    noVerifiedDomain:
      "В этом проекте нет подтверждённых доменов. Подтвердите домен, чтобы начать сканирование.",
    errTierBlocked:
      "Ваш тариф не включает этот тип сканирования. Перейдите на более высокий план.",
    errBilling: "Сканирование заблокировано лимитами тарифа. Проверьте подписку.",
    errNoPlan: "Выберите тариф в настройках, чтобы запустить скан.",
    errEmailNotVerified:
      "Чтобы запустить сканирование, нужно подтвердить email. Проверьте почту — мы прислали ссылку.",
    resendEmailLink: "Отправить письмо ещё раз",
    resendEmailSent: "Письмо отправлено. Проверьте почту, включая папку «Спам».",
    resendEmailFailed: "Не удалось отправить письмо. Попробуйте ещё раз через минуту.",
    resendEmailCooldown:
      "Письмо уже отправлено. Подождите {seconds} с и попробуйте ещё раз.",
    warmupBanner: "Подождите. Первые 20 минут данные ещё не собираются",
    stageRecon: "РАЗВЕДКА",
    stageScanner: "СКАНЕР",
    stageRbc: "РАЗБОР",
    stageExploit: "ЭКСПЛОЙТ",
  },

  overview: {
    sectionLabel: "ОБЗОР",
    recentFindings: "Свежие уязвимости",
    liveFeed: "Лента событий",
    metricFindings: "Уязвимости",
    metricHypoteses: "Гипотезы",
    metricEndpoints: "Эндпоинты",
    metricFindingsSub: "критических: {critical}, высоких: {high}",
    metricHypotesesSub: "в анализе: {reactive}, цепочек: {chain}",
    metricEndpointsSub: "разведано: {percent}%",
    viewAllFindings: "Все уязвимости",
    viewFullFeed: "Полная лента событий",
    warmingUp: "прогреваем",
    collectingData: "Собираем данные…",
    waitingForEvents: "Ждём первые события…",
    pleaseWait20: "Подождите. Первые 20 минут данные ещё не собраны.",
  },

  feed: {
    sectionLabel: "СОБЫТИЯ",
    loading: "Загружаем события…",
    loadingMore: "Подгружаем ещё…",
    empty: "Событий пока нет.",
    end: "Все события показаны.",
    counter: "событий: {events}",
  },

  findings: {
    sectionLabel: "УЯЗВИМОСТИ ({count})",
    tabAll: "Все",
    tabHigh: "Высокие",
    tabMedium: "Средние",
    tabLow: "Низкие",
    loading: "Загружаем уязвимости…",
    emptyFiltered: "Под этот фильтр уязвимостей пока нет.",
    emptyNoScan: "Нет активного сканирования — запустите его на «Обзоре».",
    sevCritical: "критическая",
    sevHigh: "высокая",
    sevMedium: "средняя",
    sevLow: "низкая",
    statusConfirmed: "подтверждена",
    statusOpen: "открыта",
    statusRejected: "отклонена",
    strictNotice:
      "Состав отчёта проверен человеком: показаны только подтверждённые им находки ({confirmed}). Исключено: {excluded}.",
    truncatedNotice: "Показаны первые {shown} из {total} находок.",
    pocLabel: "PoC",
    description: "Описание",
    cvss: "CVSS",
    score: "Скор",
    target: "Цель",
    vulnType: "Тип уязвимости",
    tool: "Инструмент",
    evidence: "Доказательства",
    recommendation: "Рекомендация",
    url: "URL",
    evidenceLabel: "ДОКАЗАТЕЛЬСТВА",
    untitled: "Уязвимость без названия",
    notAvailable: "—",
    loadFailed: "Не удалось загрузить уязвимости",
  },

  hypoteses: {
    sectionLabel: "ГИПОТЕЗЫ",
    tabAll: "Все",
    tabAnalyze: "Анализ",
    tabExploit: "Эксплойт",
    tabFinding: "Подтверждённые",
    tabRejected: "Отклонённые",
    loading: "Загружаем гипотезы…",
    emptyFiltered: "Под этот фильтр гипотез пока нет.",
    emptyNoScan: "Нет активного сканирования — запустите его, чтобы появились гипотезы.",
    badgeAnalyse: "анализ",
    badgeExploit: "эксплойт",
    badgeFinding: "подтверждена",
    badgeRejected: "отклонена",
    viewPoc: "Показать PoC",
    viewDetails: "Подробнее",
    findingKindDefault: "ГИПОТЕЗА",
    fieldReason: "Обоснование",
    fieldHowToTest: "Как проверить",
    fieldTarget: "Цель",
    statusReady: "готова",
    statusRejectedShort: "отклонена",
    statusAnalyse: "анализ",
    loadFailed: "Не удалось загрузить гипотезы",
  },

  reports: {
    sectionLabel: "ОТЧЁТЫ",
    generate: "Сформировать отчёт",
    generating: "Формируем…",
    loading: "Загружаем отчёты…",
    empty: "Отчётов пока нет. Сформируйте отчёт по текущему сканированию.",
    needScan: "Запустите сканирование, прежде чем формировать отчёт.",
    statusReady: "готов",
    statusPending: "формируется",
    notReady: "Отчёт ещё формируется — дождитесь завершения сканирования.",
    pendingBadge: "Ожидает проверки",
    pendingTitle: "Отчёт собран автоматически, человек ещё не подтвердил его состав",
    verifiedBadge: "Проверен человеком",
    verifiedTitle: "Состав отчёта вручную подтверждён человеком и актуален",
    staleBadge: "Проверка устарела",
    staleTitle:
      "После ручной проверки состав отчёта изменился — нужна повторная проверка",
    revokedBadge: "Проверка отозвана",
    revokedTitle: "Ручная проверка отчёта отозвана администратором",
    tipPending: "Ручной проверки человеком ещё не было.",
    tipVerified: "Состав отчёта подтвердил {name}, {date}.",
    tipStale: "Проверял {name}, {date}. С тех пор состав изменился — нужна повторная проверка.",
    tipRevoked: "Проверка от {date} ({name}) отозвана администратором.",
    tipCurrentCounts:
      "Сейчас: находок {total}, подтверждено {confirmed}, без решения {unreviewed}, ложных {falsePositive}.",
    tipSnapshotCounts:
      "В отчёт вошло {included} из {total}; исключено без проверки {excludedUnreviewed}, ложных {excludedFalsePositive}.",
    download: "Скачать",
    read: "Открыть",
    delete: "Удалить",
    deleteAria: "Удалить отчёт",
    confirmDeleteTitle: "Удалить этот отчёт?",
    confirmDeleteBody: "PDF и метаданные будут удалены безвозвратно.",
    confirmDeleteLabel: "Удалить отчёт",
    untitled: "Отчёт без названия",
    downloadFailed: "Не удалось скачать отчёт",
    readFailed: "Не удалось открыть отчёт",
    deleteFailed: "Не удалось удалить отчёт",
    generateFailed: "Не удалось сформировать отчёт",
    previewTitle: "Предпросмотр отчёта",
    downloadTitle: "Скачать PDF",
    deleteBody: "Отчёт и все его экспорты будут удалены.",
    loadFailed: "Не удалось открыть отчёт: {message}",
    error: "ошибка",
    scanStatus: "Статус сканирования",
    notFinished: "Сканирование не завершено — отчёт будет доступен после окончания.",
    finishedAt: "Завершено {date}",
    formatPdf: "PDF",
    formatHtml: "HTML",
    formatJson: "JSON",
    formatSarif: "SARIF",
  },

  graph: {
    sectionLabel: "ГРАФ АТАК",
  },

  chat: {
    open: "Открыть чат",
    close: "Закрыть чат",
    title: "Чат",
    collapsedLabel: "Чат",
    placeholder: "Сообщение",
    send: "Отправить",
    copy: "Скопировать",
    empty: "Здесь появятся ваши указания агенту.",
    noScan: "Не выбрано активное сканирование.",
    sendFailed: "Не удалось отправить указание агенту.",
    steeringUnavailable: "Указания агенту пока недоступны — этого эндпоинта нет в публичном API.",
    // Лента мыслей агента (итерации mission_loop)
    adminOnly: "Лента мыслей агента доступна только администраторам.",
    loadFailed: "Не удалось загрузить активность агента.",
    emptyFeed: "Агент ещё не начал рассуждать.",
    composerHint: "Управление агентом скоро — пока только просмотр",
    planning: "Планирую векторов атаки: {n}",
    structuredStep: "Прорабатываю шаг…",
    findingCritical: "КРИТИЧЕСКАЯ НАХОДКА",
    findingHigh: "Опасная находка",
    findingMedium: "Находка",
    findingLow: "Мелочь",
    findingInfo: "Заметка",
    exploit: "Запускаю эксплойт",
    step: "Шаг завершён",
    milestone: "Событие скана",
    narrativeThinking: "Агент думает…",
    narrativeFallbackTitle: "{kind} · итерация {seq}",
    missionScore: "очки {current}/{target}",
    missionStatusPending: "ожидание",
    missionStatusRunning: "выполняется",
    missionStatusCompleted: "завершено",
    missionStatusFailed: "ошибка",
    missionStatusCancelled: "отменено",
    missionStatusSkipped: "пропущено",
    kindPlan: "План",
    kindReplan: "Реплан",
    kindScore: "Оценка",
    kindOther: "Шаг",
    iterLabel: "Итерация {seq}",
    toolCallsCount: "вызовов: {count}",
    scoreDelta: "{before} → {after}",
    reasoningLabel: "Рассуждения",
    toolsLabel: "Вызовы инструментов",
    noReasoning: "Для этого шага рассуждений нет.",
    detailFailed: "Не удалось загрузить детали шага.",
    exitLabel: "код {code}",
  },

  onboarding: {
    titleFirst: "Начните первое сканирование",
    titleVerify: "Подтвердите сайт, чтобы запустить сканирование",
    subtitleVerify:
      "Добавьте TXT-запись в DNS, затем вернитесь и нажмите «Проверить».",
    siteAddress: "Адрес сайта",
    siteAddressPlaceholder: "example.com",
    siteRequired: "Введите адрес сайта",
    siteInvalid: "Похоже, это не домен. Пример: example.com или мойсайт.рф",
    projectRegistered: "Проект зарегистрирован",
    registerSite: "Зарегистрировать сайт",
    registering: "Регистрируем сайт…",
    checking: "Проверяем DNS-запись…",
    verified: "Подтверждено — открываем панель…",
    checkAgain: "Проверить снова",
    registerFailed: "Не удалось начать подтверждение",
    createFailed: "Не удалось создать проект",
    sessionExpired:
      "Эта сессия подтверждения истекла на сервере. Добавьте сайт ещё раз, чтобы получить новый TXT-токен.",
    verificationFailed: "Подтверждение не прошло",
    verificationRestarted:
      "Срок токена истёк — мы выпустили новый. Обновите TXT-запись в DNS и нажмите «Проверить ещё раз».",
    dnsType: "Тип",
    dnsName: "Имя",
    dnsValue: "Значение",
    dnsInstructions:
      "Добавьте TXT-запись с этими значениями в свой DNS, затем нажмите «Проверить снова».",
    subtitleVerifyExisting: "Подтвердите DNS для одного из своих проектов или добавьте новый сайт.",
    step1Title: "Введите адрес своего сайта. Сайт должен принадлежать вам",
    step1Placeholder: "введите адрес сайта",
    projectRegisteredTitle: "Проект зарегистрирован",
    step2Title: "Добавьте TXT-запись в свой DNS",
    whereIsIt: "Где это?",
    whereIsItUrl: "https://www.google.com/search?q=как+добавить+TXT-запись+в+DNS",
    domainVerified: "Домен подтверждён. Открываем панель…",
    iAddedRecord: "Я добавил TXT-запись — проверить",
    ttlMin: "{minutes} мин",
    ttlHour: "1 час",
    dnsCantFind:
      "Пока не нашли TXT-запись. Изменения DNS могут занять несколько минут — попробуйте чуть позже.",
    confirmDeleteTitle: "Удалить этот проект?",
    confirmDeleteBody: 'Проект «{name}» и его область будут удалены безвозвратно.',
    confirmDeleteLabel: "Удалить проект",
    deleteFailed: "Не удалось удалить проект",

    // Онбординг новичка (тур + MCP)
    chooseTitle: "Добро пожаловать",
    chooseSubtitle: "С чего хотите начать?",
    tourCardTitle: "Пройти тур",
    tourCardBody: "Быстрый разбор интерфейса — запустите скан, читайте находки, получите отчёт.",
    mcpCardTitle: "Подключить AI-агента",
    mcpCardBody: "Подключите наш MCP-сервер к своему агенту, и он будет управлять BackDoor за вас.",
    skip: "Пропустить",
    back: "Назад",
    next: "Далее",
    stepOf: "{n} из {total}",
    tourFinish: "Запустить скан",
    tour: {
      "scan-cta": {
        title: "Отсюда запускается скан",
        body: "Наведите BackDoor на подтверждённый сайт — и запустится весь пайплайн атаки.",
      },
      metrics: {
        title: "Результаты с одного взгляда",
        body: "Находки, гипотезы и найденные эндпоинты появляются в этих карточках по ходу скана.",
      },
      "scan-stages": {
        title: "Прогресс в реальном времени",
        body: "Разведка, карта, анализ, эксплойт, цепочки и отчёт — следите за каждым этапом.",
      },
      "reports-nav": {
        title: "Ваш отчёт",
        body: "Когда скан закончится, полный отчёт с рабочими эксплойтами появится в разделе «Отчёты».",
      },
    },
    mcpTitle: "Подключить AI-агента по MCP",
    mcpSubtitle: "Добавьте это в конфиг MCP вашего агента и попросите его запустить и объяснить скан.",
    mcpStep1: "Скопируйте конфиг ниже.",
    mcpStep2: "Вставьте его в настройки MCP вашего агента и подставьте свой токен.",
    mcpStep3: "Попросите агента: «Запусти скан BackDoor и объясни, что происходит».",
    mcpDone: "Выбрать тариф",
  },

  auth: {
    welcomeTitle: "Добро пожаловать",
    back: "Назад",
    emailPlaceholder: "Электронная почта",
    login: "Войти",
    signUp: "Регистрация",
    invalidEmail: "Введите корректный email",
    ssoFailed: "Не удалось запустить SSO",
    continueWith: "Войти через {provider}",
    passwordTitle: "Пароль",
    passwordPlaceholder: "Введите пароль",
    passwordRequired: "Введите пароль",
    signingIn: "Входим…",
    enter: "Войти",
    loginFailed: "Не удалось войти",
    errInvalidCredentials: "Неверный email или пароль",
    errEmailTaken: "Этот email уже зарегистрирован",
    registrationTitle: "Регистрация",
    createPassword: "Придумайте пароль",
    name: "Имя",
    surname: "Фамилия",
    organisation: "Организация",
    organisationSize: "Размер организации",
    industry: "Отрасль",
    passwordWeak: "Пароль должен быть не короче 8 символов",
    repeatPassword: "Повторите пароль",
    passwordsMatch: "Пароли совпадают",
    passwordsMismatch: "Пароли не совпадают",
    showPassword: "Показать пароль",
    hidePassword: "Скрыть пароль",
    generatePassword: "Сгенерировать надёжный пароль",
    generatingPassword: "Генерируем…",
    passwordCopied: "Надёжный пароль сгенерирован и скопирован в буфер обмена",
    passwordGenerated: "Надёжный пароль сгенерирован — сохраните его в надёжном месте",
    strengthTooShort: "Короткий",
    strengthWeak: "Слабый",
    strengthOkay: "Средний",
    strengthGood: "Хороший",
    strengthStrong: "Надёжный",
    creating: "Создаём аккаунт…",
    signupFailed: "Не удалось зарегистрироваться",
    verificationTitle: "Подтверждение",
    verificationCodePlaceholder: "Введите код подтверждения",
    verificationCodeRequired: "Введите код подтверждения из письма",
    verificationCodeShort: "Код должен быть не короче 8 символов",
    verificationFailed: "Подтверждение не прошло. Попробуйте ещё раз.",
    verificationInvalid:
      "Этот код недействителен, истёк или уже использован. Запросите новый.",
    verificationTooMany: "Слишком много попыток. Подождите немного и попробуйте снова.",
    sendCodeFailed: "Не удалось отправить письмо с кодом",
    checking: "Проверяем…",
    resendCode: "Отправить код повторно",
    codeSentTo: "Код подтверждения отправлен на {email}.",
    canResendIn: "Можно отправить ещё раз через {seconds} сек",
    freshCodeSent: "Новое письмо с кодом отправлено.",
    maskedFallback: "вашу почту",
    forgotPassword: "Забыли пароль?",
    forgotTitle: "Сброс пароля",
    forgotIntro:
      "Введите email от аккаунта — пришлём ссылку для сброса пароля.",
    forgotSubmit: "Отправить ссылку",
    forgotSending: "Отправляем…",
    forgotSent: "Проверьте {email} — там будет ссылка для сброса.",
    forgotResend: "Отправить ссылку ещё раз",
    forgotResendIn: "Можно отправить ещё раз через {seconds} сек",
    forgotFailed: "Не удалось отправить ссылку",
    backToLogin: "Вернуться ко входу",
    resetTitle: "Новый пароль",
    resetIntro: "Введите новый пароль, чтобы завершить восстановление.",
    resetSubmit: "Сохранить и войти",
    resetSaving: "Сохраняем…",
    resetFailed: "Не удалось сбросить пароль",
    resetTokenMissing: "Ссылка для сброса некорректна или повреждена.",
    resetTokenInvalid:
      "Эта ссылка для сброса недействительна, истекла или уже использована. Запросите новую.",
    changePasswordTitle: "Сменить пароль",
    currentPasswordPlaceholder: "Текущий пароль",
    newPasswordPlaceholder: "Новый пароль",
    changePasswordSubmit: "Сменить пароль",
    changePasswordSaving: "Обновляем…",
    changePasswordSuccess: "Пароль обновлён.",
    changePasswordFailed: "Не удалось сменить пароль",
    changePasswordInvalid: "Текущий пароль неверен.",
    currentPasswordRequired: "Введите текущий пароль",
    industryTechnology: "ИТ и технологии",
    industryFinance: "Финансы",
    industryHealthcare: "Здравоохранение",
    industryManufacturing: "Промышленность",
    industryRetail: "Ритейл",
    industryGovernment: "Госсектор",
    industryEducation: "Образование",
    industryEnergy: "Энергетика",
    industryMedia: "Медиа",
    industryOther: "Другое",
    callbackSigningIn: "Завершаем вход…",
    callbackRedirecting: "Возвращаемся на вход…",
    callbackErrorUNAUTHENTICATED: "Не удалось войти. Попробуйте ещё раз.",
    callbackErrorPERMISSION_DENIED: "Доступ через этого провайдера запрещён.",
    callbackErrorNOT_FOUND: "Запрос на вход не найден или истёк.",
    callbackErrorINVALID_ARGUMENT: "Некорректный запрос на вход.",
    callbackErrorINTERNAL: "Ошибка сервиса аутентификации. Попробуйте позже.",
    callbackErrorUnknown: "Не удалось войти.",
    callbackErrorMissingTokens: "Ответ авторизации неполный. Попробуйте ещё раз.",
  },

  newProject: {
    title: "Новый проект",
    namePlaceholder: "Название проекта",
    hostPlaceholder: "example.com",
    invalidHost: "Введите корректный хост",
    createFailed: "Не удалось создать проект",
    createDomainFailed: "Проект создан, но не удалось добавить домен",
    createBusy: "Создаём…",
  },

  // Названия юрисдикций приходят из API по-английски и показываются как есть в
  // обоих языках — переводятся только эти окружающие строки интерфейса.
  jurisdiction: {
    placeholder: "Юрисдикция отчёта (необязательно)",
    caption:
      "Задаёт раздел отчёта «Legal & regulatory risks». Не связана с языком интерфейса и языком отчёта; применится к следующему отчёту.",
    dialogTitle: "Юрисдикция проекта",
    menuItem: "Юрисдикция…",
    saveFailed: "Не удалось изменить юрисдикцию",
  },

  settings: {
    sectionLabel: "НАСТРОЙКИ",
    tourHeading: "Тур по продукту",
    tourBody: "Пройдите демо на локальных данных — добавьте сайт, запустите скан, прочитайте находку и получите отчёт.",
    tourMobile: "Тур по продукту доступен на компьютере.",
    tourCta: "Пройти тур",
    payments: "Оплата",
    currentPlanLabel: "Текущий план",
    noPlanShort: "Нет плана",
    subscriptionUntil: "Подписка до",
    paymentsScansSub: "Информация о подписке появится после загрузки.",
    pickPlanCta: "Выбрать план",
    changePlanCta: "Сменить план",
    paymentsProcessing: "Обрабатываем…",
    checkoutFailed: "Не удалось открыть оплату",
    checkoutStarted: "Открываем оплату — сейчас перенаправим…",
    checkoutSuccess: "Оплата получена — план обновлён.",
    checkoutProcessing:
      "Оплата обрабатывается — обновите страницу через минуту, чтобы увидеть изменения.",
    checkoutCancelled: "Оплата отменена — деньги не списаны.",
    checkoutMissing: "Не пришёл URL оплаты",
    payNow: "Оплатить {amount}",
    checkoutCurrencyUnavailable: "Этот план пока недоступен в вашей валюте.",
    checkoutEmailNotVerified:
      "Сначала подтвердите email — мы прислали ссылку на почту. После подтверждения оплата станет доступна.",
    scanPackTitle: "Дополнительные сканы",
    scanPackPerScan: "{price} / скан",
    scanPackQuantity: "Количество",
    scanPackDecrement: "Уменьшить количество",
    scanPackIncrement: "Увеличить количество",
    scanPackBuy: "Купить {count} за {total}",
    scanPackUnavailable: "Доп.сканы сейчас недоступны.",
    scanPackLoadFailed: "Не удалось загрузить цену доп.сканов",
    profile: "Профиль",
    email: "Электронная почта",
    password: "Пароль",
    displayName: "Отображаемое имя",
    profileEditDisabled: "Редактирование профиля будет доступно после обновления API.",
    language: "Язык интерфейса",
    saveChanges: "Сохранить",
    profileInfo: "Профиль",
    transactionHistoryLabel: "ИСТОРИЯ ПЛАТЕЖЕЙ",
    paymentMethodLabel: "СПОСОБ ОПЛАТЫ",
    invoicesEmpty: "Платежей пока нет",
    invoicesLoadFailed: "Не удалось загрузить платежи",
    downloadInvoice: "Скачать счёт",
    downloadUnavailable: "Доступно после оплаты",
    invoiceLabel: "Подписка",
    invoiceStatusPaid: "Оплачено",
    invoiceStatusPending: "Ожидает оплаты",
    invoiceStatusExpired: "Не оплачен / Просрочен",
    invoiceStatusFailed: "Ошибка оплаты",
    invoiceStatusRefunded: "Возврат",
    invoiceStatusIssued: "Выставлен",
    noPlanTitle: "Нет активного плана",
    noPlanBody:
      "Выберите тариф, чтобы запускать сканирования. Можно сменить или отменить в любой момент.",
    choosePlanHeading: "Выбор тарифа",
    currentPlanBadge: "Текущий",
    choosePlan: "Выбрать",
    choosingPlan: "Переходим к оплате…",
    scansPerMonth: "{count} сканов в месяц",
    scansUnlimited: "Безлимит сканов",
    plansLoadFailed: "Не удалось загрузить тарифы",
    taxNote: "Цены указаны без налога — итоговая сумма видна на странице оплаты.",
  },

  paywall: {
    title: "Подписка — безлимитные сканирования",
    subtitle:
      "Цены указаны за один актив. Второй и каждый следующий актив — $5,000/месяц.",
    perAsset: "в месяц за актив",
    save: "Экономия {amount}",
    mostPopular: "Самый популярный",
    bestValue: "Выгоднее всего — {months} месяца бесплатно",
    m1Title: "1 месяц",
    m1Billed: "{amount} ежемесячно",
    m1Tagline: "Попробуйте без обязательств. Отмена в любой момент.",
    m1FeatUnlimited: "Безлимитные сканирования вашего актива",
    m1FeatDepth: "Стандартная глубина сканирования",
    m1FeatRetests: "Безлимитные перепроверки после исправлений",
    m1FeatStart: "Старт сканирования в течение 12 часов",
    m1FeatReports: "Отчёты с рабочими эксплойтами + дашборд",
    m1FeatIntegrations: "Slack, Telegram, вебхуки",
    m1FeatSupport: "Поддержка в течение 8 рабочих часов",
    m1Cta: "Начать с 1 месяца",
    m3Title: "3 месяца",
    m3Billed: "{amount} за квартал",
    m3Tagline: "Вдвое больше вычислительной мощности на цель и автоматические исправления.",
    m3Lead: "Всё из тарифа «1 месяц», плюс:",
    m3FeatDepth: "Расширенная глубина — в 2 раза больше мощности на цель",
    m3FeatQueue: "Приоритетная очередь — старт в течение 4 часов",
    m3FeatAutoPatch: "Auto Patch — готовый к мержу PR с исправлением",
    m3FeatChains: "Цепочки атак между вашими активами",
    m3FeatSupport: "Выделенная поддержка (ответ ≤ 4 часов)",
    m3FeatWhiteLabel: "White-label отчёты",
    m3FeatJira: "Интеграция с Jira и CI/CD",
    m3FeatContract: "Договор + NDA вместо стандартного предложения",
    m3Cta: "Выбрать 3 месяца",
    m12Title: "12 месяцев",
    m12Billed: "{amount} за год",
    m12Tagline: "Непрерывный режим: агент не останавливается.",
    m12Lead: "Всё из тарифа «3 месяца», плюс:",
    m12FeatDepth: "Максимальная глубина — в 4 раза больше мощности на цель",
    m12FeatContinuous: "Непрерывный режим без расписания и лимитов",
    m12FeatVip: "VIP-очередь — старт в течение 1 часа, 24/7",
    m12FeatRemediation: "Автоматическое устранение по вашим правилам",
    m12FeatPaths: "Моделирование путей атак до критичных активов",
    m12FeatTam: "Выделенный Technical Account Manager + приватный Slack Connect",
    m12FeatCompliance: "Пакет комплаенса: SOC 2, ISO 27001, PCI DSS",
    m12FeatBoardReport: "Ежеквартальный отчёт по безопасности для руководства",
    m12FeatIntegrations: "Интеграции ServiceNow, SIEM, SSO/SAML",
    m12FeatPriceLock: "Цена зафиксирована на 24 месяца",
    m12FeatSla: "Индивидуальный SLA с финансовыми гарантиями",
    m12Cta: "Выбрать 12 месяцев",
  },

  errors: {
    generic: "Что-то пошло не так.",
    network: "Ошибка сети. Проверьте соединение.",
    serverUnavailable: "Сервер временно недоступен ({status}). Попробуйте ещё раз через минуту.",
    tooManyRequests: "Слишком много запросов — повторим автоматически чуть позже.",
  },

  consent: {
    title: "Согласие на cookies",
    body: "Мы используем cookies для работы приложения и — с вашего согласия — для аналитики (Google Analytics).",
    privacy: "Политика конфиденциальности",
    necessaryOnly: "Только необходимые",
    allowAll: "Разрешить все",
  },
  tour: {
    next: "Далее",
    back: "Назад",
    skip: "Пропустить",
    stepOf: "{{current}} из {{total}}",
    banner: "Демо-режим — данные локальные, ничего не отправляется в движок",
    bannerBack: "Вернуться к туру",
    bannerExit: "Выйти из демо",
    bannerShort: "Демо-режим",
    stages: {
      site: "Сайт",
      verify: "Проверка",
      scan: "Скан",
      finding: "Находка",
      report: "Отчёт",
    },
    alarm: {
      title: "Найдена критическая уязвимость",
      body: "SQL-инъекция на {host} — данные клиентов доступны без входа.",
      cta: "Открыть",
    },
    welcome: {
      title: "Добро пожаловать в BackDoor",
      titlenamed: "Добро пожаловать в BackDoor, {name}!",
      body: "Это демо — добавьте сайт, запустите скан, прочитайте находку и получите отчёт. Занимает около четырёх минут.",
      start: "Начать тур",
    },
    site: {
      title: "Начните со своего сайта",
      body: "Всё начинается с домена. Мы подставили демо-магазин — оставьте его или впишите свой.",
    },
    register: {
      title: "Добавьте сайт",
      body: "Нажмите «Зарегистрировать сайт», чтобы завести проект.",
      nudge: "Нажмите «Зарегистрировать сайт», чтобы продолжить.",
    },
    dns: {
      title: "Подтвердите, что сайт ваш",
      body: "При реальном сканировании вы добавляете эту TXT-запись в DNS — так мы убеждаемся, что сайт ваш.",
    },
    verify: {
      title: "Проверьте запись",
      body: "Нажмите «Проверить». В демо проверка проходит сразу; настоящая ждёт, пока обновится DNS.",
      nudge: "Нажмите, чтобы проверить запись.",
    },
    project: {
      title: "Ваш проект",
      body: "Сайт подтверждён. Отсюда вы запускаете скан, открываете прошлые сканы по стрелке и добавляете новый сайт «плюсом».",
    },
    start: {
      title: "Запустите скан",
      body: "Настоящий скан идёт до четырёх часов. Нажмите «Start scan».",
      nudge: "Нажмите «Start scan», чтобы запустить.",
    },
    recon: {
      title: "Разведка",
      body: "Движок изучает сайт: поддомены, порты, стек. Нажмите «Далее», чтобы продвинуть скан.",
    },
    map: {
      title: "Прогресс в реальном времени",
      body: "События идут в ленту, граф растёт по ходу работы движка. «Далее», чтобы продолжить.",
    },
    chat: {
      title: "Ассистент",
      body: "Откройте ассистента — он простым языком рассказывает, что делает скан.",
      nudge: "Нажмите на панель чата, чтобы открыть.",
    },
    chatRead: {
      title: "Рассказ простым языком",
      body: "Ассистент превращает сырые события скана в понятный рассказ. Прочитайте, потом «Далее».",
    },
    analyze: {
      title: "Что нашёл агент",
      body: "Три счётчика: «Уязвимости» — подтверждённые дыры, «Гипотезы» — что агент сейчас проверяет, «Эндпоинты» — сколько точек входа он изучил.",
    },
    finding: {
      title: "Критическая находка",
      body: "Агент подтвердил SQL-инъекцию. Откройте её, чтобы увидеть детали.",
      nudge: "Нажмите на находку, чтобы открыть.",
    },
    read: {
      title: "Находка",
      body: "Разверните её: что нашли, где и доказательство.",
      nudge: "Нажмите на находку, чтобы развернуть.",
    },
    fix: {
      title: "Как исправить",
      body: "У каждой находки есть рекомендация — конкретные шаги, чтобы закрыть проблему. «Далее», чтобы продолжить скан.",
    },
    more: {
      title: "Ещё находки",
      body: "К концу скана здесь появляются новые находки. Фильтруйте их по критичности этими вкладками.",
    },
    toGraph: {
      title: "Граф атаки",
      body: "Откройте «Attack graph», чтобы увидеть, как движок прошёл по сайту.",
      nudge: "Нажмите «Attack graph» в сайдбаре.",
    },
    graph: {
      title: "Граф атаки",
      body: "Каждый узел — шаг движка. «Далее», чтобы завершить скан.",
    },
    toReport: {
      title: "Ваш отчёт",
      body: "Скан завершён. Откройте «Reports», чтобы получить отчёт.",
      nudge: "Нажмите «Reports» в сайдбаре.",
    },
    report: {
      title: "Отчёт готов",
      body: "Каждый скан даёт отчёт, проверенный аналитиком.",
    },
    readReport: {
      title: "Прочитайте",
      body: "Откройте отчёт, чтобы посмотреть его.",
      nudge: "Нажмите «Читать», чтобы открыть превью.",
    },
    preview: {
      title: "Отчёт",
      body: "Сводка для руководства, каждая находка с доказательством и рекомендацией — готово к отправке.",
    },
    download: {
      title: "Заберите с собой",
      body: "Скачайте отчёт файлом, чтобы передать команде или клиенту.",
    },
    done: {
      title: "Это весь цикл",
      body: "Добавить сайт, подтвердить, просканировать, прочитать находки с исправлениями, получить отчёт. Попробуете на своём сайте?",
      cta: "Завершить и добавить свой сайт",
    },
  },
};
